module.exports = __webpack_public_path__ + "static/media/Schedule_Illustration.11d866ee.svg";